(function () {
  'use strict';

  function initMenu() {
    const mainDisclosure = document.querySelector('.main-menu__disclosure');
    const mainMenuContent = document.querySelector('.main-menu__content');

    function isMobile() {
      return window.innerWidth < 950;
    }

    // --------------------------------------------------------------------------
    // MOBILE MENU LOGIC (< 950px)
    // --------------------------------------------------------------------------
    // Sanitize initial state on mobile load so menu doesn't treat initial Liquid "open" attribute as open menu
    if (isMobile() && mainDisclosure) {
      mainDisclosure.removeAttribute('open');
      mainDisclosure.classList.remove('is-open');
      document.body.classList.remove('mobile-menu-active');
    }

    function openMainMenu() {
      if (mainDisclosure) {
        mainDisclosure.setAttribute('open', '');
        mainDisclosure.classList.add('is-open');
      }
      document.body.classList.add('mobile-menu-active', 'overflow-hidden');
    }

    function closeMainMenu() {
      if (mainDisclosure) {
        mainDisclosure.removeAttribute('open');
        mainDisclosure.classList.remove('is-open', 'is-closing');
      }
      closeAllSubmenus();
      document.body.classList.remove('mobile-menu-active', 'overflow-hidden');
    }

    function toggleMainMenu(e) {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }
      if (!isMobile()) return;

      const isOpen = document.body.classList.contains('mobile-menu-active') || (mainDisclosure && mainDisclosure.classList.contains('is-open'));
      if (isOpen) {
        closeMainMenu();
      } else {
        openMainMenu();
      }
    }

    function closeAllSubmenus() {
      const openSubmenus = document.querySelectorAll('.main-nav details[open], .main-nav details.is-open');
      openSubmenus.forEach(function (details) {
        details.removeAttribute('open');
        details.classList.remove('is-open', 'is-closing');
      });
    }

    function openSubmenu(detailsElem) {
      if (!detailsElem) return;
      const parentList = detailsElem.closest('ul');
      if (parentList) {
        const siblings = parentList.querySelectorAll(':scope > li > details[open], :scope > li > details.is-open');
        siblings.forEach(function (sib) {
          if (sib !== detailsElem) {
            sib.removeAttribute('open');
            sib.classList.remove('is-open', 'is-closing');
          }
        });
      }
      detailsElem.setAttribute('open', '');
      detailsElem.classList.add('is-open');
      const childContainer = detailsElem.querySelector('.main-nav__child');
      if (childContainer) {
        childContainer.scrollTop = 0;
      }
    }

    function closeSubmenu(detailsElem) {
      if (!detailsElem) return;
      detailsElem.removeAttribute('open');
      detailsElem.classList.remove('is-open', 'is-closing');
    }

    // --------------------------------------------------------------------------
    // DESKTOP HOVER LOGIC (>= 950px)
    // --------------------------------------------------------------------------
    let desktopHoverTimeout = null;

    document.addEventListener('mouseover', function (e) {
      if (isMobile()) return;

      const detailsElem = e.target.closest('.main-nav > li > details');
      if (detailsElem) {
        if (desktopHoverTimeout) {
          clearTimeout(desktopHoverTimeout);
          desktopHoverTimeout = null;
        }
        const allOpen = document.querySelectorAll('.main-nav > li > details[open], .main-nav > li > details.is-open');
        allOpen.forEach(function (d) {
          if (d !== detailsElem) {
            d.removeAttribute('open');
            d.classList.remove('is-open');
          }
        });
        detailsElem.setAttribute('open', '');
        detailsElem.classList.add('is-open');
      }
    });

    document.addEventListener('mouseout', function (e) {
      if (isMobile()) return;

      const detailsElem = e.target.closest('.main-nav > li > details');
      if (detailsElem) {
        const related = e.relatedTarget;
        if (!related || !detailsElem.contains(related)) {
          if (desktopHoverTimeout) clearTimeout(desktopHoverTimeout);
          desktopHoverTimeout = setTimeout(function () {
            detailsElem.removeAttribute('open');
            detailsElem.classList.remove('is-open');
          }, 150);
        }
      }
    });

    // --------------------------------------------------------------------------
    // GLOBAL CLICK & KEYBOARD LISTENERS
    // --------------------------------------------------------------------------
    document.addEventListener('click', function (e) {
      if (!isMobile()) return;

      // 1. Toggle main menu button click (header toggle or bottom nav toggle)
      const toggleBtn = e.target.closest('.main-menu__toggle, .js-mobile-bottom-nav-toggle-menu');
      if (toggleBtn) {
        toggleMainMenu(e);
        return;
      }

      // 2. Back button click inside submenu (.js-back)
      const backBtn = e.target.closest('.js-back');
      if (backBtn) {
        e.preventDefault();
        e.stopPropagation();
        const parentDetails = backBtn.closest('details');
        if (parentDetails) {
          closeSubmenu(parentDetails);
        }
        return;
      }

      // 3. Submenu toggle click (.js-toggle or summary inside .main-nav)
      const navToggle = e.target.closest('.main-nav .js-toggle, .main-nav summary');
      if (navToggle) {
        const detailsElem = navToggle.closest('details');
        if (detailsElem) {
          e.preventDefault();
          e.stopPropagation();
          const isOpen = detailsElem.hasAttribute('open') || detailsElem.classList.contains('is-open');
          if (isOpen) {
            closeSubmenu(detailsElem);
          } else {
            openSubmenu(detailsElem);
          }
          return;
        }
      }

      // 4. Click outside menu to close if active
      if (document.body.classList.contains('mobile-menu-active')) {
        const isClickInside = mainMenuContent && mainMenuContent.contains(e.target);
        if (!isClickInside && !toggleBtn) {
          closeMainMenu();
        }
      }
    });

    // Handle Escape key to close menu
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isMobile() && document.body.classList.contains('mobile-menu-active')) {
        closeMainMenu();
      }
    });

    // Reset state on window resize
    window.addEventListener('resize', function () {
      if (!isMobile() && document.body.classList.contains('mobile-menu-active')) {
        closeMainMenu();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMenu);
  } else {
    initMenu();
  }
})();
